"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTranslation = getTranslation;
/**
 * Static imports for locale JSON files, keyed by language code (e.g. fr-FR).
 * Required for Vite/ESM bundlers that do not support dynamic import() with variable paths.
 */
const LOCALE_MODULES = {
    'fr-FR': () => Promise.resolve().then(() => __importStar(require('./locales/fr.json'))),
    'en-GB': () => Promise.resolve().then(() => __importStar(require('./locales/en.json'))),
    'de-DE': () => Promise.resolve().then(() => __importStar(require('./locales/de.json'))),
    'es-ES': () => Promise.resolve().then(() => __importStar(require('./locales/es.json'))),
    'es-MX': () => Promise.resolve().then(() => __importStar(require('./locales/es_MX.json'))),
    'pt-PT': () => Promise.resolve().then(() => __importStar(require('./locales/pt.json'))),
    'uk-UA': () => Promise.resolve().then(() => __importStar(require('./locales/uk.json'))),
    'ar-DZ': () => Promise.resolve().then(() => __importStar(require('./locales/ar_DZ.json'))),
    'ar-MA': () => Promise.resolve().then(() => __importStar(require('./locales/ar_MA.json'))),
    'tr-TR': () => Promise.resolve().then(() => __importStar(require('./locales/tr.json'))),
    'ro-RO': () => Promise.resolve().then(() => __importStar(require('./locales/ro.json'))),
};
/**
 * Load translations for a language: from remote (api) if useRemote, else from shared locales.
 */
async function getTranslation(language, options) {
    if (options.useRemote) {
        return options.api.get(`/translations/${language}`, undefined, {
            showErrorToast: false,
        });
    }
    const loadLocale = LOCALE_MODULES[language];
    if (!loadLocale) {
        throw new Error(`Translation file not found for language: ${language}`);
    }
    try {
        const mod = await loadLocale();
        const translations = mod.default;
        return {
            translations,
            lastUpdated: new Date(),
        };
    }
    catch (error) {
        console.error(`Failed to load local translation for ${language}:`, error);
        throw new Error(`Translation file not found for language: ${language}`);
    }
}
